<template>
  <AbsPopup id="ChangeAdult" title="등급변경신청" type="confirm" :initButtonList="buttonList" @close="$emit('close')" @submit="submit">
    <template #body>
      <div class="popup-body">
        <div class="default">
          <span>'[{{ booktitle }}]'은 [<span :class="adultClass(true)">{{ adult(true) }}</span>]으로 등록된 책 입니다.</span>
          <span>[<span :class="adultClass(false)">{{ adult(false) }}</span>]으로 변경하시면 [<span class="require">성인인증 절차를<br /> 진행하지 않은 유저</span>]는 더 이상 해당 책을 열람할 수<br /> 없게 됩니다.</span>
        </div>
        <div v-if="!hasAdult" class="notadult">
          <span>'<span :class="adultClass(true)">{{ adult(true) }}</span>'에서 '<span :class="adultClass(false)">{{ adult(false) }}</span>'으로 변경하기 위해선 본인<span class="require">(성인)</span> 인증이 필요 합니다.</span>
          <span>본인<span class="require">(성인)</span> 인증 절차를 진행 하시겠습니까?</span>
        </div>
        <div v-else class="adult">
          <div class="agree">
            <input type="checkbox" id="adultStep" v-model="adultStep" />
            <label for="adultStep">
              <span>위의 내용에 동의 합니다.</span>
            </label>
          </div>
          <div v-if="adultCert" class="agree">
            <input type="checkbox" id="adultCert" v-model="adultCert" />
            <label for="adultCert">
              <span>본인인증 완료</span>
            </label>
          </div>
          <div v-else class="button">
            <Ubutton size="small" text="본인인증하기" :state="adultStep? 'active' : 'disable'" @click.native="adultOpenClick"/>
          </div>
        </div>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import {getTime, State} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  created () {
    console.log(this.option.param)
    this.$http.post('/api/user/proofinfo').then((e) => {
      console.log(e)
      if (e.success) {
        this.data = e
        this.hasAdult = true
        // this.hasAdult = Boolean(e.adult && e.myproof)
      } else {
        this.hasAdult = false
      }
      this.$emit('loading', false)
    })
  },
  mounted () {
  },
  beforeDestroy () {
  },
  data () {
    return {
      hasAdult: false,
      data: null,
      adultStep: false,
      adultOpen: false,
      adultCert: false
    }
  },
  name: 'ChangeAdult',
  watch: {
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: (!this.hasAdult) ? '인증하기' : '등급변경하기', state: this.buttonState, click: this.submit}
      ]
    },
    buttonState () {
      if (!this.hasAdult) {
        return 'active'
      } else {
        if (this.adultCert) {
          return 'active'
        } else {
          return 'disable'
        }
      }
    },
    booktitle () {
      console.log(this.option.param.book)
      return this.option.param.book.title
    },
    isAdult () {
      return Boolean(this.option.param.book.state & State.ADULT)
    }
  },
  methods: {
    adult (bo) {
      if (this.isAdult) {
        if (bo) {
          return '성인물 등급'
        } else {
          return '전체 이용가 등급'
        }
      } else {
        if (bo) {
          return '전체 이용가 등급'
        } else {
          return '성인물 등급'
        }
      }
    },
    adultClass (bo) {
      if (this.isAdult) {
        if (bo) {
          return 'require'
        } else {
          return 'active'
        }
      } else {
        if (bo) {
          return 'active'
        } else {
          return 'require'
        }
      }
    },
    adultOpenClick (e) {
      window.IMP.certification({
        company: 'https://upenbe.com',
        merchant_uid: this.$store.getters.id + getTime(),
        phone: this.phone
      }, (rsp) => {
        console.log(rsp)
        if (rsp.success) {
          this.$http.post('/api/library/bookAdultCert', {id: this.option.param.book._id, imp: rsp.imp_uid}).then(es => {
            console.log(es)
            if (es.success) {
              this.adultCert = true
            }
          })
        }
      })
    },
    submit () {
      console.log(this.data)
      if (!this.hasAdult) {
        this.data.type = 'adult'
        this.openPopup('AdultPopup', this.data, (e) => {
          console.log(e)
          if (e.result) {
            this.$emit('submit')
          } else {
            this.$emit('close')
          }
        })
      } else {
        if (this.adultCert) {
          this.$emit('submit')
        }
      }
    }
  },
  components: {
    AbsPopup
  }
}
</script>

<style scoped>
#ChangeAdult {
  padding: 10px 0;
  width: 380px;
  color: var(--text-base);
}
.popup-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;

}
.popup-body .default {
  display: flex;
  flex-direction: column;
  line-height: 35px;
  padding: 0px 5px;
  text-align: left;
}
.popup-body .notadult {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--line-guide);
  padding: 10px;
  line-height: 25px;
  text-align: left;
}
.adult {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.adult .agree {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.adult .agree input[type=checkbox] {
  display: none;
}
.adult .agree input[type=checkbox] + label {
  position: relative;
  display: inline-block;
  padding-left: 23px;
  cursor: pointer;
}
.adult .agree input[type=checkbox] + label::before {
  content: 'v';
  color: var(--line-base);
  position: absolute;
  line-height: 14px;
  width: 14px;
  height: 14px;
  border-radius:14px;
  border: 2px solid var(--line-base);
  left: 0px;
  text-align: center;
  top: 50%;
  font-size: 14px;
  transform: translateY(-50%);
}
.adult .agree input[type=checkbox]:checked + label::before {
  content: 'v';
  color: var(--active);
  border: 2px solid var(--active);
}
.adult .agree input[type=checkbox]:checked + label {
  color: var(--active);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/ChangeAdult.vue